// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2M0aS","loaderOuter":"PageOverlayLoader_loaderOuter__3F39O"};